import { render, staticRenderFns } from "./products-business.edit.vue?vue&type=template&id=715c0b42&scoped=true&"
import script from "./products-business.edit.vue?vue&type=script&lang=js&"
export * from "./products-business.edit.vue?vue&type=script&lang=js&"
import style0 from "./products-business.edit.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./products-business.edit.vue?vue&type=style&index=1&id=715c0b42&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715c0b42",
  null
  
)

component.options.__file = "products-business.edit.vue"
export default component.exports